<script>
import { PlansSizeStore } from '../../PlansSizeStore';
import { BuildIncludedServices } from "./BuildIncludedServices";
import allowed_included_services from "./allowed_included_services";

export let membership_type = null;
export let parsedPlans = [];
/**
 * on single plan load the single layout.
 */
export let plan = null;

/**
 * @type {BuildIncludedServices}
 */
export let additionals_instance = null;



let device = "is-desktop";
$: device = $PlansSizeStore >= 900 ? "is-desktop" : "is-mobile";

</script>
{#if allowed_included_services(membership_type)}
    <included-services class="is-grid is-gap-10">
        <div class="is-flex is-gap-10 is-align-items-center included-services-title">
            <i class="iconfont x-outline-add has-text-black font-size-28"></i>
            <h2 class="font-size-20 fw600">
                {window.get_contents_all("ctn_2HvGkk") ?? "Servicios incluidos"}
            </h2>
        </div>
        <included-benefits class="columns is-centered">
            <!-- desktop -->
            {#if device === "is-desktop"}
                {#if plan === null}
                    <div class="column">
                        <div class="options-benefits is-grid" style="gap:19.6px !important;padding:20px">
                            {#each Object.values(additionals_instance.GetAdditionalsInterface()) as item}
                                <h3 class="font-restricted-size-14 m-0 benefit-name is-gap-10 is-flex is-align-items-center">
                                    <span>
                                        <i class="iconfont {item.icon}"></i>
                                    </span>
                                    <span class="font-restricted-size-14 fw600 full-width">
                                        {item.title}
                                    </span>
                                </h3>
                            {/each}
                        </div>
                    </div>
                    {#each parsedPlans as plan}
                        <card-plan class="column column-card-plan card-plan-content container-plan-{plan.__id__}">
                            <section class="subcontainer is-plan padding-40 has-radius">
                                <div class="values-benefits is-grid" style="gap:19.6px !important;">
                                    {#each Object.values(additionals_instance.GetAdditionalsInterface()) as item, key}
                                        <p class="benefit-value is-justify-content-center font-size-14 m-0 has-text-centered is-flex">
                                            {#if typeof (item?.value ?? null) === "boolean"}
                                                    <i class="icon-tripod-checklist-alt has-text-success font-size-20"></i>
                                                {:else}
                                                    {additionals_instance.set_additional_benefit(
                                                        plan, Object.keys(additionals_instance.GetAdditionalsInterface())[[key]]
                                                    )}
                                            {/if}
                                        </p>
                                    {/each}
                                </div>
                            </section>
                        </card-plan>
                    {/each}
                {/if}
            {/if}
            <!-- mobile -->
            {#if device === "is-mobile"}
                {#if plan !== null}
                    <div class="column">
                        <div class="options-benefits mobile is-grid">
                            {#each Object.values(additionals_instance.GetAdditionalsInterface()) as item, key}
                                <div class="box is-grid m-0" style="justify-content:center;">
                                    <h3 class="font-restricted-size-16 is-justify-content-center m-0 benefit-name is-gap-10 is-flex is-align-items-center">
                                        <span>
                                            <i class="iconfont font-restricted-size-20 {item.icon}"></i>
                                        </span>
                                        <span class="font-restricted-size-16 fw600 full-width">
                                            {item.title}
                                        </span>
                                    </h3>
                                    <p class="has-text-centered">
                                        {#if typeof (item?.value ?? null) === "boolean"}
                                                <i class="icon-tripod-checklist-alt has-text-success font-restricted-size-24"></i>
                                            {:else}
                                            {additionals_instance.set_additional_benefit(
                                                plan, Object.keys(additionals_instance.GetAdditionalsInterface())[[key]]
                                            )}
                                        {/if}
                                    </p>
                                </div>
                            {/each}
                        </div>
                    </div>
                {/if}
            {/if}
        </included-benefits>
    </included-services>
{/if}
<style>
.options-benefits{
    gap: 19.6px !important;
    padding: 20px;
}
.options-benefits.mobile{
    gap: 10px !important;
    padding: 0 12px 12px 12px;
}
.options-benefits.mobile .box{
    border: 1px solid var(--color-extralightGrey);
}
@media only screen and (max-width:900px){
    .included-services-title{
        justify-content: center;
    }
}
</style>
